import { render } from "./FlawsDisplay.vue?vue&type=template&id=63e025a6&scoped=true"
import script from "./FlawsDisplay.vue?vue&type=script&lang=js"
export * from "./FlawsDisplay.vue?vue&type=script&lang=js"

import "./FlawsDisplay.vue?vue&type=style&index=0&id=63e025a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e025a6"]])

export default __exports__